export default class Product {
    constructor(
        name,
        alu,
        details,
        costPrice,
        price,
        salePrice,
        brandId,
        brandName,
        isDeal,
        productStatus,
        availableStock,
        paymentsAndReturns,
        shippingAndDelivery,
        categoryId,
        images,
    ) {
        this.name = name;
        this.alu = alu;
        this.brandId = brandId;
        this.categoryId = categoryId;
        this.productStatus = productStatus;
        this.availableStock = availableStock;
        this.costPrice = costPrice;
        this.price = price;
        this.salePrice = salePrice;
        this.brandName = brandName;
        this.isDeal = isDeal;
        this.paymentsAndReturns = paymentsAndReturns;
        this.shippingAndDelivery = shippingAndDelivery;
        this.details = details;
        this.images = images;
    }
}
